import { createSlice } from '@reduxjs/toolkit';

// Per-playlist state (Varjo vs Mac All-In-One)
const playlistInitialState = {
  availableVideos: [0],
  selectedVideo: null,
  progress: 0,
  totalVideos: 0,
};

const initialState = {
  // Shared language (used by training pages and exam)
  language: 'English',
  // State per playlist so progress is independent
  byPlaylist: {
    varjo: { ...playlistInitialState },
    mac: { ...playlistInitialState },
  },
};

const videoSlice = createSlice({
  name: 'videos',
  initialState,
  reducers: {
    setTotalVideos: (state, action) => {
      const { playlistId, total } = action.payload;
      if (!state.byPlaylist[playlistId]) state.byPlaylist[playlistId] = { ...playlistInitialState };
      const playlist = state.byPlaylist[playlistId];
      playlist.totalVideos = total;
      if (playlist.progress < 100) {
        playlist.progress = calculateProgress(playlist.availableVideos.length, total);
      }
    },
    resetAvailableVideos: (state, action) => {
      const { playlistId, payload } = action.payload;
      const list = payload !== undefined ? payload : [0];
      if (!state.byPlaylist[playlistId]) state.byPlaylist[playlistId] = { ...playlistInitialState };
      const playlist = state.byPlaylist[playlistId];
      playlist.availableVideos = list;
      playlist.selectedVideo = null;
      playlist.progress = calculateProgress(list.length, playlist.totalVideos);
    },
    unlockVideo: (state, action) => {
      const { playlistId, nextVideo } = action.payload;
      const playlist = state.byPlaylist[playlistId];
      if (!playlist) return;
      if (!playlist.availableVideos.includes(nextVideo)) {
        playlist.availableVideos.push(nextVideo);
        if (playlist.progress < 100) {
          playlist.progress = calculateProgress(playlist.availableVideos.length, playlist.totalVideos);
        }
      }
    },
    setSelectedVideo: (state, action) => {
      const { playlistId, video } = action.payload;
      if (!state.byPlaylist[playlistId]) state.byPlaylist[playlistId] = { ...playlistInitialState };
      state.byPlaylist[playlistId].selectedVideo = video;
    },
    setLanguage: (state, action) => {
      state.language = action.payload;
    },
    resetSelectedVideo: (state, action) => {
      const { playlistId } = action.payload;
      if (state.byPlaylist[playlistId]) state.byPlaylist[playlistId].selectedVideo = null;
    },
    setManualProgress: (state, action) => {
      const { playlistId, progress } = action.payload;
      if (!state.byPlaylist[playlistId]) return;
      state.byPlaylist[playlistId].progress = Math.max(0, Math.min(progress, 100));
    },
  },
});

// Helper function to calculate progress dynamically
const calculateProgress = (availableVideosCount, totalVideos) => {
  if (totalVideos === 0) return 0; // Prevent division by zero
  return Math.min(((availableVideosCount - 1) / totalVideos) * 100, 100);
};

export const {
  setTotalVideos,
  resetAvailableVideos,
  unlockVideo,
  setSelectedVideo,
  resetSelectedVideo,
  setManualProgress,
  setLanguage,
} = videoSlice.actions;

export default videoSlice.reducer;